import type { SidebarGroup } from "@altek/ui/components/layout/AppSidebar";

/** «Sistem» bölümünün adresi — rayda bu varsa kişinin açabildiği ayarlar vardır. */
export const ADMIN_SETTINGS_HREF = "/admin/system";

/**
 * PROFİL MENÜSÜNDEKİ «AYARLAR» NEREYE GİDER — ya da gitmez.
 *
 * Üç hâli oldu. Önce herkes `/admin/settings`'e gidiyordu: yönetici olmayan herkes «Sayfa
 * bulunamadı» görüyordu. Sonra (8 Ekim 2026) satır kişiye göre bir yere gidiyordu — «Sistem»
 * rayındaysa oraya, değilse `/profile`'a — ve kırıklık bitti ama yenisi başladı: çalışanın
 * menüsünde «Profilim» ve «Ayarlar» üst üste duruyor ve İKİSİ DE aynı sayfayı açıyordu.
 * İkisini de tıklayan kişi, satırlardan birinin aslında bir kapı olmadığını öğreniyor.
 *
 * Şimdi: kendi ayarları olana adres, olmayana `null` — kit `v3.23.0`'dan beri `onSettings`
 * verilmediğinde satırı hiç çizmiyor. Kural, kitin geri kalanıyla aynı: gidecek yeri olmayan
 * eylem soluk değil YOK.
 *
 * KARARIN KAYNAĞI RAY, ayrı bir yetki listesi değil. Menü kişiye «Sistem»i gösteriyorsa ayarlar
 * oradadır; iki yerde iki kural olsaydı biri diğerinden önce eskirdi.
 */
export function settingsHrefFor(groups: readonly SidebarGroup[]): string | null {
  const reachable = groups.some((group) =>
    group.items.some((item) => item.href === ADMIN_SETTINGS_HREF),
  );
  return reachable ? ADMIN_SETTINGS_HREF : null;
}
